export const debug = {
  enabled: [] as string[],
  log: (scope: string, message: string, ...args: any[]) => {
    if (!isDebugEnabled(scope)) return;
    console.log(...mapArgsToConsole(scope, message, args));
  },
  warn: (scope: string, message: string, ...args: any[]) => {
    if (!isDebugEnabled(scope)) return;
    console.warn(...mapArgsToConsole(scope, message, args));
  },
  error: (scope: string, message: string, ...args: any[]) => {
    if (!isDebugEnabled(scope)) return;
    console.error(...mapArgsToConsole(scope, message, args));
  },
};

function isDebugEnabled(scope: string) {
  if (!debug.enabled || debug.enabled.length === 0) return false;
  return debug.enabled.some(s => scope.startsWith(s));
}

function mapArgsToConsole(prefix: string, message: string, args: any[]) {
  return [`${prefix}: ${message}`, ...args];
}

if (global != null) {
  try {
    (global as any)['FWEngineDebug'] = {
      enable(...keys: string[]) {
        debug.enabled.push(...keys);
        return debug.enabled;
      },
      disable(...keys: string[]) {
        if (!keys) {
          debug.enabled = [];
          return;
        }
        debug.enabled = debug.enabled.filter(k => !keys.includes(k));
      },
    };
  } catch (err) {
    console.warn('FWEngineDebug not available in global scope', { err });
  }
}
